import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../../../interfaces/interface-bakend/seguridad/users/user.interface';
import { UsuarioService } from '../../../../services/shared/usuario.service';
import { Perfil } from '../../../../interfaces/interface-bakend/seguridad/acl/perfil.interface';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { CursosService } from 'src/app/services/cursos/cursos.service';
import { AlumnoTitulo, Disciplina, Titulo } from 'src/app/interfaces/interface-bakend/cursos/titulo.interface';
import { Alumno } from 'src/app/interfaces/interface-bakend/cursos/alumno.interface';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2'
import { SignoSede } from 'src/app/interfaces/interface-bakend/entidades/signo-sede.interface';
import { SignoSedeService } from 'src/app/services/entidades/signo-sedes.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PATOLOGIAS_CONFIG } from '@interfaces/interface-bakend/patologias/patologias';

@Component({
  selector: 'app-usuario-modificacion',
  templateUrl: './usuario-modificacion.component.html',
  styleUrls: ['./usuario-modificacion.component.scss']
})
export class UsuarioModificacionComponent implements OnInit, AfterViewInit {

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['nombre', 'disciplina', 'otorgamiento', 'vencimiento', 'certifica', 'observaciones', '_id'];
  dataSource: any;

  forma: FormGroup;
  formTitulos: FormGroup;
  usuario: User;
  selectPerfiles: Perfil[];
  flagLoaded = false;
  flagDisableButton = false;
  flagValidForma = false;
  estado = true;
  isChecked = true;
  emailChecked: boolean = false;
  titulos: Titulo[] = [];
  disciplinas: Disciplina[] = [];
  titulosDelAlumno: AlumnoTitulo[] = [];
  subscriptions: Subscription;

  data$: Observable<AlumnoTitulo[]>;
  setTitulo: any;
  editaTitulo = false;
  tituloSeleccionado: Titulo;
  sedes: SignoSede[];
  sedesSeleccionadas: any[] = [];
  isMultipleSelectionEnabled = true;
  desdeAfiliados: boolean;

  /** Solo ADMIN/SYSADMIN pueden editar nombre y apellido. */
  puedeEditarIdentidad = false;

  /** Buscador del selector de sedes. */
  sedeBusqueda = '';

  //Patologias
  patologiasDisponibles: string[] = PATOLOGIAS_CONFIG;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private usuarioService: UsuarioService,
    private guiMsjService: GuiMsjService,
    private cursosService: CursosService,
    public dialog: MatDialog,
    private signoSedeService: SignoSedeService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.desdeAfiliados = params['desdeAfiliados'] || false;
    });
  }

  createListenersStateForm() {  
    return this.forma.statusChanges.subscribe(status => {
      // console.log(this.forma.value);
    });
  }

  ngAfterViewInit(): void {
    this.getEstadoVariables();
  }

  reset() {
    this.formTitulos.reset();
    this.editaTitulo = false;
  }

  async createForm() {
    // Los catálogos se piden ANTES de armar el form: el <select> tiene que
    // tener sus opciones cuando se escribe el valor, si no el navegador
    // termina mostrando otra opción (o ninguna) sin avisar.
    await this.getPerfiles();
    await this.getSedes();

    const perfilId = this.usuario?.perfil?._id || null;
    const perfilExiste = !!perfilId && (this.selectPerfiles || []).some((p) => p._id === perfilId);

    this.forma = new FormGroup({
      nombrePersona: new FormControl({ value: this.usuario?.nombrePersona || '', disabled: !this.puedeEditarIdentidad }),
      apellidoPersona: new FormControl({ value: this.usuario?.apellidoPersona || '', disabled: !this.puedeEditarIdentidad }),
      nickname: new FormControl({ value: this.usuario?.nickname || 'SIN REGISTRAR SU NICKNAME', disabled: true }),
      email: new FormControl({ value: this.usuario?.email || '', disabled: false }),
      perfil: new FormControl({ value: perfilExiste ? perfilId : null, disabled: this.desdeAfiliados }, [Validators.required]),
      estado: new FormControl(this.usuario?.suspendido ?? false, Validators.required),
      email_verified: new FormControl(this.usuario?.email_verified ?? false, Validators.required),
      signoSedes: new FormControl({ value: this.sedesSeleccionadas || [], disabled: this.desdeAfiliados }, Validators.required), // Marcar las sedes que tiene el usuario
      patologias: new FormControl(this.usuario?.patologias || [])
    });

    this.formTitulos = new FormGroup({
      titulo: new FormControl(Validators.required),
      fechaOtorgamiento: new FormControl(new Date(), Validators.required),
      fechaVencimiento: new FormControl(new Date(), Validators.required),
      certifica: new FormControl(true),
      disciplina: new FormControl(Validators.required),
      nivel: new FormControl('', Validators.required),
      observaciones: new FormControl('')
    });

    this.flagLoaded = true;
  }

  async loadDataTable() {
    await this.cursosService.getTitulosAlumnosFindAllByAlumno((await this.cursosService.findAlumnoByUsuario(this.usuario._id))._id).then((titulos: AlumnoTitulo[]) => {
      this.dataSource = new MatTableDataSource(titulos);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async loadDataPage() {
    await this.loadDataTable();
    this.flagLoaded = true;
    return;
  }

  /**
   * Trae el usuario SIEMPRE del backend al entrar a la pantalla.
   * Del listado sólo se usa el _id (o el ?id= de la URL): el objeto que queda
   * en memoria puede estar viejo o haber sido mutado por un guardado anterior,
   * y esta pantalla no debe pintar nada que no venga fresco de la API.
   */
  async getEstadoVariables() {
    const id = this.activatedRoute.snapshot.queryParamMap.get('id')
      || this.usuarioService.getUsuarioSeleccionado()?._id;

    if (!id) {
      this.router.navigateByUrl('/usuarios-listado');
      return;
    }

    const usuarioFresco = await this.usuarioService.getFindOne(id);

    if (!usuarioFresco) {
      this.router.navigateByUrl('/usuarios-listado');
      return;
    }

    this.usuario = usuarioFresco;
    this.isChecked = usuarioFresco.suspendido ?? false;
    this.emailChecked = usuarioFresco.email_verified ?? false;
    this.sedesSeleccionadas = usuarioFresco.signoSedes && usuarioFresco.signoSedes.length > 0
      ? [...usuarioFresco.signoSedes]
      : [];

    await this.cargarPermisos();
    await this.createForm();
    this.createListenersStateForm();
    this.flagLoaded = true;
  }

  /**
   * Arma el payload del PUT sin tocar this.usuario: mutar el objeto compartido
   * dejaba la copia en memoria inconsistente (perfil como string, delegacion y
   * disciplina convertidas) y esa basura se pintaba en la próxima apertura.
   */
  async setDataForma(): Promise<User> {
    const usuarioEditado: User = { ...this.usuario };

    if (this.puedeEditarIdentidad) {
      usuarioEditado.nombrePersona = this.forma.value.nombrePersona;
      usuarioEditado.apellidoPersona = this.forma.value.apellidoPersona;
    }

    usuarioEditado.nickname = this.forma.value.nickname;
    usuarioEditado.perfil = this.forma.value.perfil;
    usuarioEditado.suspendido = this.forma.value.estado;
    usuarioEditado.email_verified = this.forma.value.email_verified;
    usuarioEditado.email = this.forma.value.email;
    usuarioEditado.patologias = this.forma.value.patologias;

    // ✅ Si queda verificado, limpiar PIN
    if (this.forma.value.email_verified === true) {
      usuarioEditado.pin = null;
    }

    if (typeof usuarioEditado.delegacion === 'string') {
      usuarioEditado.delegacion = {
        _id: usuarioEditado.delegacion
      };
    }

    if (typeof usuarioEditado.disciplina === 'string') {
      usuarioEditado.disciplina = {
        _id: usuarioEditado.disciplina
      };
    }

    usuarioEditado.signoSedes = this.sedesSeleccionadas;

    return usuarioEditado;
  }

  async getPerfiles() {
    this.selectPerfiles = await this.usuarioService.getPerfiles();
  }

  async getSedes() {
    this.sedes = await this.signoSedeService.getSedes();
  }

  async ngSubmit() {
    this.flagDisableButton = true;
    await this.guiMsjService.msjFormSubmit('Guardando');
    try {
      const usuarioActualizado = await this.setDataForma();
      const resultado = await this.usuarioService.updateOne(usuarioActualizado);
      if (resultado) {
        Swal.close();
        if (this.desdeAfiliados) {
          this.router.navigateByUrl('/afiliados-listado');
        } else {
          this.router.navigateByUrl('/usuarios-listado');
        }
        this.guiMsjService.msjFormSubmit('UsuarioModificadoOK');
      } else {
        Swal.close();
        this.guiMsjService.msjFormSubmit('UsuarioModificadoError');
      }
    } catch (error) {
      Swal.close();
      console.error('Error al modificar usuario:', error);

      // Detectar error de email duplicado
      const isEmailDuplicate = error?.message?.includes('EMAIL_EXISTENTE') ||
                              error?.error?.message?.includes('EMAIL_EXISTENTE') ||
                              (error?.status === 400 && error?.message?.includes('EMAIL_EXISTENTE'));

      if (isEmailDuplicate) {
        await Swal.fire({
          icon: 'error',
          title: 'Email duplicado',
          text: 'El correo electrónico que intenta asignar ya está registrado en el sistema. Por favor, elija otro.',
          confirmButtonText: 'Aceptar'
        });
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error al modificar usuario',
          text: 'Ocurrió un error inesperado. Por favor, intente nuevamente más tarde.',
          confirmButtonText: 'Aceptar'
        });
      }
    } finally {
      this.flagDisableButton = false;
    }
  }

  async getDisciplinas() {
    await this.cursosService.getDisciplinas().then((disciplinas: Disciplina[]) => {
      this.disciplinas = disciplinas;
    });
  }

  async getTitulosAlumnos() {
    await this.cursosService.getTitulosAlumnosFindAllByAlumno(await (await this.cursosService.findAlumnoByUsuario(this.usuario._id))._id).then((titulos: AlumnoTitulo[]) => {
      this.titulosDelAlumno = titulos;
    });
  }

  get fechaOtorgamientoNoValida() {
    return this.formTitulos.get('fechaOtorgamiento').invalid && this.formTitulos.get('fechaOtorgamiento').touched;
  }

  get fechaVencimientoNoValida() {
    return this.formTitulos.get('fechaVencimiento').invalid && this.formTitulos.get('fechaVencimiento').touched;
  }

  get nombrePersona() {
    return this.forma.get('nombrePersona').invalid && this.forma.get('nombrePersona').touched;
  }

  get apellidoPersona() {
    return this.forma.get('apellidoPersona').invalid && this.forma.get('apellidoPersona').touched;
  }

  get nickname() {
    return this.forma.get('nickname').invalid && this.forma.get('nickname').touched;
  }

  get email() {
    return this.forma.get('email').invalid && this.forma.get('email').touched;
  }

  get perfil() {
    return this.forma.get('perfil').invalid && this.forma.get('perfil').touched;
  }

  get sede() {
    return this.forma.get('signoSedes').invalid && this.forma.get('signoSedes').touched;
  }

  // ---------- Permisos ----------
  async cargarPermisos(): Promise<void> {
    try {
      const userLogon = await this.authService.getUserLogon();
      const perfilKey = userLogon?.perfil?.key;
      this.puedeEditarIdentidad = ['ADMIN', 'SYSADMIN'].includes(perfilKey);
    } catch (error) {
      this.puedeEditarIdentidad = false;
    }
  }

  // ---------- Selector de sedes (buscador + chips) ----------
  get sedesFiltradas(): SignoSede[] {
    const termino = (this.sedeBusqueda || '').trim().toLowerCase();
    const base = this.sedes || [];
    return termino
      ? base.filter((sede) => (sede.nombre || '').toLowerCase().includes(termino))
      : base;
  }

  get sedesSeleccionadasData(): SignoSede[] {
    return (this.sedes || []).filter((sede) => this.sedesSeleccionadas.includes(sede._id));
  }

  get todasSedesSeleccionadas(): boolean {
    return (this.sedes?.length || 0) > 0 && this.sedesSeleccionadas.length === this.sedes.length;
  }

  sedeEstaSeleccionada(id: string): boolean {
    return this.sedesSeleccionadas.includes(id);
  }

  toggleSede(sede: SignoSede): void {
    this.sedesSeleccionadas = this.sedeEstaSeleccionada(sede._id)
      ? this.sedesSeleccionadas.filter((id) => id !== sede._id)
      : [...this.sedesSeleccionadas, sede._id];
    this.sincronizarSedesForm();
  }

  quitarSede(id: string): void {
    this.sedesSeleccionadas = this.sedesSeleccionadas.filter((s) => s !== id);
    this.sincronizarSedesForm();
  }

  toggleTodasSedes(): void {
    this.sedesSeleccionadas = this.todasSedesSeleccionadas
      ? []
      : (this.sedes || []).map((sede) => sede._id);
    this.sincronizarSedesForm();
  }

  private sincronizarSedesForm(): void {
    const control = this.forma.get('signoSedes');
    control.setValue(this.sedesSeleccionadas);
    control.markAsTouched();
  }

}

// import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
// import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, Router } from '@angular/router';
// import { User } from '../../../../interfaces/interface-bakend/seguridad/users/user.interface';
// import { UsuarioService } from '../../../../services/shared/usuario.service';
// import { Perfil } from '../../../../interfaces/interface-bakend/seguridad/acl/perfil.interface';
// import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
// import { CursosService } from 'src/app/services/cursos/cursos.service';
// import { AlumnoTitulo, Disciplina, Titulo } from 'src/app/interfaces/interface-bakend/cursos/titulo.interface';
// import { Alumno } from 'src/app/interfaces/interface-bakend/cursos/alumno.interface';
// import { MatSort } from '@angular/material/sort';
// import { MatPaginator } from '@angular/material/paginator';
// import { MatTableDataSource } from '@angular/material/table';
// import { Observable, Subscription } from 'rxjs';
// import { MatDialog } from '@angular/material/dialog';
// import Swal from 'sweetalert2'
// import { SignoSede } from 'src/app/interfaces/interface-bakend/entidades/signo-sede.interface';
// import { SignoSedeService } from 'src/app/services/entidades/signo-sedes.service';


// @Component({
//   selector: 'app-usuario-modificacion',
//   templateUrl: './usuario-modificacion.component.html',
//   styleUrls: ['./usuario-modificacion.component.scss']
// })
// export class UsuarioModificacionComponent implements OnInit, AfterViewInit {

//   /* Data Table*/
//   @ViewChild(MatSort) sort: MatSort;
//   @ViewChild(MatPaginator) paginator: MatPaginator;
//   displayedColumns: string[] =
//     [
//       'nombre', 'disciplina', 'otorgamiento', 'vencimiento', 'certifica', 'observaciones', '_id'
//     ];
//   dataSource: any;

//   forma: FormGroup;
//   formTitulos: FormGroup;
//   usuario: User;
//   selectPerfiles: Perfil[];
//   flagLoaded = false;
//   flagDisableButton = false;
//   flagValidForma = false;
//   estado = true;
//   isChecked = true;
//   emailChecked: boolean = false;
//   titulos: Titulo[] = [];
//   disciplinas: Disciplina[] = [];
//   titulosDelAlumno: AlumnoTitulo[] = [];
//   subscriptions: Subscription;

//   data$: Observable<AlumnoTitulo[]>;
//   setTitulo: any;
//   editaTitulo: boolean = false;
//   tituloSeleccionado: Titulo;
//   sedes: SignoSede[];
//   sedesSeleccionadas: any;
//   isMultipleSelectionEnabled: boolean = true;
//   desdeAfiliados: boolean;  // Variable para capturar el parámetro

//   constructor(
//     private router: Router,
//     private activatedRoute: ActivatedRoute,  // Inyecta ActivatedRoute
//     private usuarioService: UsuarioService,
//     private guiMsjService: GuiMsjService,
//     private cursosService: CursosService,
//     public dialog: MatDialog,
//     private signoSedeService: SignoSedeService
//   ) {

//   }

//   ngOnInit(): void {
//     // Captura el parámetro desdeAfiliados
//     this.activatedRoute.queryParams.subscribe(params => {
//       this.desdeAfiliados = params['desdeAfiliados'] || false;
//     });
//   }

//   createListenersStateForm() {  
//     return this.forma.statusChanges.subscribe( async status => {
//       // console.log(this.forma.value);
//     });
//   }

//   ngAfterViewInit(): void {
//     this.getEstadoVariables();
//   }

//   reset() {
//     this.formTitulos.reset();
//     this.editaTitulo = false;
//   }

//   async createForm() {

//     this.forma = new FormGroup({
//         nombrePersona: new FormControl({ value: this.usuario.nombrePersona || 'SIN REGISTRAR SU NOMBRE', disabled: true }),
//         apellidoPersona: new FormControl({ value: this.usuario.apellidoPersona || 'SIN REGISTRAR SU APELLIDO', disabled: true }),
//         nickname: new FormControl({ value: this.usuario.nickname || 'SIN REGISTRAR SU NICKNAME', disabled: true }),
//         email: new FormControl({ value: this.usuario.email || '', disabled: false }),
//         perfil: new FormControl((this.usuario.perfil ? this.usuario.perfil._id : null), [Validators.required]),
//         estado: new FormControl({ value: this.usuario.suspendido }, Validators.required),
//         email_verified: new FormControl({ value: this.usuario.email_verified }, Validators.required),
//         signoSedes: new FormControl('', Validators.required) // Marcar las sedes que tiene el usuario
//     });

//     this.formTitulos = new FormGroup({
//         titulo: new FormControl(Validators.required),
//         fechaOtorgamiento: new FormControl(new Date(), Validators.required),
//         fechaVencimiento: new FormControl(new Date(), Validators.required),
//         certifica: new FormControl(true),
//         disciplina: new FormControl(Validators.required),
//         nivel: new FormControl('', Validators.required),
//         observaciones: new FormControl('')
//     });

//  }



//   // async createForm() {
//   //   this.forma = new FormGroup({
//   //     nombrePersona: new FormControl({ value: this.usuario.nombrePersona || 'SIN REGISTRAR SU NOMBRE', disabled: true }),
//   //     apellidoPersona: new FormControl({ value: this.usuario.apellidoPersona || 'SIN REGISTRAR SU APELLIDO', disabled: true }),
//   //     nickname: new FormControl({ value: this.usuario.nickname || 'SIN REGISTRAR SU NICKNAME', disabled: true }),
//   //     email: new FormControl({ value: this.usuario.email || '', disabled: true }),
//   //     perfil: new FormControl((this.usuario.perfil ? this.usuario.perfil._id : null), [Validators.required]),
//   //     estado: new FormControl({ value: this.usuario.suspendido }, Validators.required),
//   //     email_verified: new FormControl({ value: this.usuario.email_verified }, Validators.required),
//   //     signoSedes: new FormControl('', Validators.required)
//   //   });

//   //   this.formTitulos = new FormGroup({
//   //     titulo: new FormControl(Validators.required),
//   //     fechaOtorgamiento: new FormControl(new Date(), Validators.required),
//   //     fechaVencimiento: new FormControl(new Date(), Validators.required),
//   //     certifica: new FormControl(true),
//   //     disciplina: new FormControl(Validators.required),
//   //     nivel: new FormControl('', Validators.required),
//   //     observaciones: new FormControl('')
//   //   })
//   // }

//   async loadDataTable() {
//     await this.cursosService.getTitulosAlumnosFindAllByAlumno((await this.cursosService.findAlumnoByUsuario(this.usuario._id))._id).then((titulos: AlumnoTitulo[]) => {
//       this.dataSource = new MatTableDataSource(titulos);
//       this.dataSource.sort = this.sort;
//       this.dataSource.paginator = this.paginator;
//     })
//   }

//   applyFilter(event: Event) {
//     const filterValue = (event.target as HTMLInputElement).value;
//     this.dataSource.filter = filterValue.trim().toLowerCase();
//   }

//   async loadDataPage() {
//     await this.loadDataTable();
//     this.flagLoaded = true;
//     return;
//   }

//   async getUsuario() {
//     this.isChecked = this.usuarioService.getUsuarioSeleccionado().suspendido;
//     this.emailChecked = this.usuarioService.getUsuarioSeleccionado().email_verified;

//     const signoSedes = this.usuarioService.getUsuarioSeleccionado().signoSedes;

//     if (signoSedes && signoSedes.length > 0) {
//       this.sedesSeleccionadas = signoSedes;
//     }

//     return this.usuario = this.usuarioService.getUsuarioSeleccionado();
//   }


//   async getEstadoVariables() {
//     if (this.usuarioService.getUsuarioSeleccionado() === undefined) {
//       this.router.navigateByUrl('/usuarios-listado');
//       return;
//     } else {
//       await this.getUsuario();
//       await this.getPerfiles();
//       await this.getSedes();
//       await this.createForm();
//       // await this.getDisciplinas();
//       // await this.getTitulosAlumnos();
//       // await this.loadDataPage();
//       this.createListenersStateForm()
//       this.flagLoaded = true;
//     }
//   }

//   async setDataForma(): Promise<User> {
//     this.usuario.nickname = this.forma.value.nickname;
//     this.usuario.perfil = this.forma.value.perfil;
//     this.usuario.suspendido = this.forma.value.estado;
//     this.usuario.email_verified = this.forma.value.email_verified;
//     this.usuario.email = this.forma.value.email;

//     if (typeof this.usuario.delegacion === 'string') {
//       this.usuario.delegacion = {
//         _id: this.usuario.delegacion
//       };
//     }

//     if (typeof this.usuario.disciplina === 'string') {
//       this.usuario.disciplina = {
//         _id: this.usuario.disciplina
//       };
//     }
//     this.usuario.email_verified = this.forma.value.email_verified;
//     // this.usuario.signoSedes = [this.forma.value.signoSedes];
//     this.usuario.signoSedes = this.forma.value.signoSedes;

//     return this.usuario;
//   }

//   async getPerfiles() {
//     this.selectPerfiles = await this.usuarioService.getPerfiles();
//   }

//   async getSedes() {
//     this.sedes = await this.signoSedeService.getSedes();
//   }

//   async ngSubmit() {
//     this.flagDisableButton = true;
//     await this.guiMsjService.msjFormSubmit('Guardando');
//     const flag = await this.usuarioService.updateOne(await this.setDataForma());
//     if (flag) {
//       Swal.close();
//       if (this.desdeAfiliados) {
//         this.router.navigateByUrl('/afiliados-listado');
//       } else {
//         this.router.navigateByUrl('/usuarios-listado'); 
//       }
//       this.guiMsjService.msjFormSubmit('UsuarioModificadoOK');
//     } else {
//       Swal.close();
//       this.guiMsjService.msjFormSubmit('UsuarioModificadoError');
//     }
//   }

//   async getDisciplinas() {
//     await this.cursosService.getDisciplinas().then((disciplinas: Disciplina[]) => {
//       this.disciplinas = disciplinas;
//     });
//   }

//   async getTitulosAlumnos() {
//     await this.cursosService.getTitulosAlumnosFindAllByAlumno(await (await this.cursosService.findAlumnoByUsuario(this.usuario._id))._id).then((titulos: AlumnoTitulo[]) => {
//       this.titulosDelAlumno = titulos;
//     });
//   }

//   /* validaciones form */

//   get fechaOtorgamientoNoValida() {
//     return this.formTitulos.get('fechaOtorgamiento').invalid && this.formTitulos.get('fechaOtorgamiento').touched;
//   }

//   get fechaVencimientoNoValida() {
//     return this.formTitulos.get('fechaVencimiento').invalid && this.formTitulos.get('fechaVencimiento').touched;
//   }

//   get nombrePersona() {
//     return this.forma.get('nombrePersona').invalid && this.forma.get('nombrePersona').touched;
//   }

//   get sede() {
//     return this.forma.get('signoSedes').invalid && this.forma.get('signoSedes').touched;
//   }

// }
